// src/components/layouts/app/header/desktop/TopBar.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ShoppingCart, Search, Truck, FileText } from 'lucide-react';
import { CountryDropdown } from './CountryDropdown';
import { LangCurrencyDropdown } from './LangCurrencyDropdown';
import { CompteMenu } from './CompteMenu';

interface TopBarProps {
  onCartClick: () => void;
  onFavoritesClick: () => void;
  cartItemCount?: number;
  favItemCount?: number;
}

export const TopBar: React.FC<TopBarProps> = ({ 
  onCartClick, 
  onFavoritesClick, 
  cartItemCount = 0, 
  favItemCount = 0 
}) => {
  const [isSearchMobileVisible, setIsSearchMobileVisible] = useState(false);

  const handleLogin = () => {
    console.log('Ouvrir modal de connexion');
  };

  const handleRegister = () => {
    console.log('Ouvrir modal d\'inscription');
  };

  const handleForgotPassword = () => {
    console.log('Ouvrir récupération mot de passe');
  };

  const handleContinueWithoutAccount = () => {
    console.log('Continuer en navigation anonyme');
  };

  return (
    <>
      <div className="container mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-4">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0 transition-transform duration-300 hover:scale-105">
          <img src="/assets/logo/v2/logonissirec.png" alt="NISSI GROUP INTL" className="h-10 w-auto drop-shadow-md" />
        </Link>

        {/* Zone centrale (Country & Lang) */}
        <div className="hidden lg:flex items-center gap-6 text-sm">
          <CountryDropdown />
          <div className="w-px h-5 bg-gray-300" />
          <LangCurrencyDropdown />
        </div>

        {/* Actions utilisateur */}
        <div className="flex items-center gap-3">
          {/* Favoris */}
          <button 
            onClick={onFavoritesClick} 
            className="relative p-2 rounded-full bg-gray-200 text-black hover:bg-gray-300 active:bg-gray-400 transition-all duration-200"
          >
            <Heart className="w-5 h-5" />
            {favItemCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-bold rounded-full min-w-[20px] h-5 px-1 flex items-center justify-center shadow-sm ring-2 ring-white">
                {favItemCount}
              </span>
            )}
          </button>

          {/* Panier */}
          <button 
            onClick={onCartClick} 
            className="relative p-2 rounded-full bg-gray-200 text-black hover:bg-gray-300 active:bg-gray-400 transition-all duration-200"
          >
            <ShoppingCart className="w-5 h-5" />
            {cartItemCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-primary text-white text-[10px] font-bold rounded-full min-w-[20px] h-5 px-1 flex items-center justify-center shadow-sm ring-2 ring-white">
                {cartItemCount}
              </span>
            )}
          </button>

          {/* Devis express */}
          <Link
            to="/devis"
            className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full bg-primary text-white hover:bg-primary/90 transition-all duration-200 shadow-sm"
          >
            <FileText className="w-4 h-4" />
            <span className="text-sm font-medium">Devis express</span>
          </Link>

          {/* Menu compte (remplace le bouton Se connecter) */}
          <CompteMenu
            onLoginClick={handleLogin}
            onRegisterClick={handleRegister}
            onForgotPasswordClick={handleForgotPassword}
            onContinueWithoutAccount={handleContinueWithoutAccount}
          />

          {/* Recherche mobile */}
          <button 
            className="lg:hidden p-2 text-black hover:text-primary"
            onClick={() => setIsSearchMobileVisible(!isSearchMobileVisible)}
          >
            <Search className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Barre de recherche mobile */}
      {isSearchMobileVisible && (
        <div className="lg:hidden px-4 pb-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
            <input
              type="text"
              placeholder="Rechercher un produit..."
              className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-primary/50"
            />
          </div>
        </div>
      )}
    </>
  );
};